"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const parse_1 = require("./parse");
const makePlace_1 = require("./parse/makePlace");
exports.default = (ssn) => {
    const { gender, year, month, place, rank, controlKey } = (0, parse_1.getParts)(ssn);
    const { countyCode, code } = (0, makePlace_1.getParts)(place);
    return [gender, year, month, countyCode, code, rank, controlKey].join(" ");
};
//# sourceMappingURL=format.js.map